<template>
  <div id="app">
    <keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "./components/header";
import Footer from "./components/footer";
import Pagination from "./components/pagination";
Vue.use(Header);
Vue.use(Footer);
Vue.use(Pagination);
export default {
  name: 'App'
}
</script>

<style>
@import "./assets/css/reset.css";
@import "./assets/css/swiper.min.css";
</style>


// WEBPACK FOOTER //
// src/App.vue